<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/paydone/home-bg.jpg')"
      class="white--text"
      gradient="to bottom, rgba(11, 28, 61, .9), rgba(0,0,0,.4)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center mx-auto"
          height="100%"
          max-width="700"
          width="100%"
        >
          <base-subheading
            weight="regular"
            class="text-uppercase"
            :title="$t('sections.hero.subheading.title1')"
          />

          <base-heading
            size="text-h3"
            :title="$t('sections.hero.heading.title')"
            weight="medium"
          />
          <base-subheading
            weight="light"
            size="text-h5"
            class="text-h5"
            :title="$t('sections.hero.subheading.title2')"
          />

          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn @click="scrollToAboutProduct">
              {{ $t('sections.hero.btn.1') }}
            </base-btn>

            <span class="font-weight-bold ml-6 mr-4 my-4">
              {{ $t('sections.hero.or') }}
            </span>

            <base-btn
              :ripple="false"
              class="secondary"
              to="/about"
            >
              {{ $t('sections.hero.btn.2') }}
            </base-btn>
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },
    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },
    methods: {
      scrollToAboutProduct () {
        const el = document.getElementById('about-our-product')
        el.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
      },
    },
  }
</script>
